import React from 'react'
import PropTypes from 'prop-types'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import settings from '../../libs/settings'
import { BIOLOGICS, MANAGE_OTHER_USERS, MANAGE_OWN_USERS, PHARMA } from '../../libs/permissions'

const styles = theme => ({
  nestedList: {
    paddingTop: 2,
    paddingBottom: 2
  },
  nestedNestedList: {
    paddingTop: 0,
    paddingBottom: 0
  },
  firstLevelItem: {
    background: 'linear-gradient(to bottom,#fff 0%,#ebf3fc 70%,#e3eefa 71%,#d6e5f8 100%)',
    paddingLeft: 8,
    paddingRight: 8,
    opacity: '1 !important'
  },
  firstLevelItemText: {
    '& .MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
  secondLevelItem: {
    backgroundColor: '#E2ECF8',
    paddingLeft: 14,
    paddingRight: 8,
    marginBottom: 2,
    '&:hover': {
      backgroundColor: '#C3D7EF !important'
    }
  },
  secondLevelItemText: {
    paddingLeft: 0,
    paddingRight: 0
  },
  rootItemText: {
    '&:first-child': {
      paddingRight: 0
    }
  },
  thirdLevelItem: {
    backgroundColor: '#E2ECF8',
    paddingLeft: 28,
    paddingRight: 8,
    marginBottom: 2,
    '&:hover': {
      backgroundColor: '#C3D7EF !important'
    }
  },
  selectedItem: {
    backgroundColor: '#C3D7EF !important'
  },
  accountHelp: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16,
    padding: '0 4px'
  },
  helpTitle: {
    color: '#333333',
    fontWeight: 600
  },
  helpHr: {
    backgroundColor: '#5392CE',
    height: 5,
    width: '100%',
    margin: '4px 0',
    border: 0
  },
  helpBody: {
    fontSize: 13,
    padding: '0 4px',
    lineHeight: 1.5
  },
  accountOwner: {
    fontSize: 13,
    padding: 8,
    lineHeight: 1.5
  },
  list: {
    paddingTop: '4px',
    paddingBottom: '4px'
  }
})

class MenuComponent extends React.PureComponent {
  render () {
    const { classes, claims, history, accountOwner } = this.props

    const [hasManageOwnUsers, hasEmailPreferences, hasFavorites] = [
      claims.includes(MANAGE_OWN_USERS),
      claims.includes(MANAGE_OTHER_USERS),
      claims.includes(PHARMA) || claims.includes(BIOLOGICS)
    ]
    const currentPath = history && history.location && history.location.pathname
    const qsEmail = (history.location && history.location.search && history.location.search.split('?email=')[1]) ? `?email=${history.location.search.split('?email=')[1]}` : ''

    return (
      <React.Fragment>
        <List dense className={classes.list} component='nav'>
          <ListItem className={classes.firstLevelItem} component='a' href='https://secure.ipdanalytics.com/User/Home' button>
            <ListItemText className={classes.firstLevelItemText} primary='Home' />
          </ListItem>
          <ListItem className={classes.firstLevelItem} classes={{disabled: classes.firstLevelItem}} button disabled>
            <ListItemText className={classes.firstLevelItemText} primary='My Account' />
          </ListItem>
          <List className={classes.nestedList} dense component='div'>
            <ListItem
              className={classes.secondLevelItem}
              classes={{selected: classes.selectedItem}}
              component={Link}
              to={`/${qsEmail}`}
              selected={currentPath === '/'}
              button
            >
              <ListItemText classes={{root: classes.rootItemText, dense: classes.secondLevelItemText}} primary='Profile Information' />
            </ListItem>
            {hasEmailPreferences && settings.featureToggles['MANAGE_EMAILS']
              ? <ListItem
                className={classes.secondLevelItem}
                classes={{selected: classes.selectedItem}}
                component={Link}
                to={`/manage-emails${qsEmail}`}
                selected={currentPath === '/manage-emails'}
                button
              >
                <ListItemText classes={{root: classes.rootItemText, dense: classes.secondLevelItemText}} primary='Customize Emails &amp; Alerts' />
              </ListItem>
              : null
            }
            {hasFavorites && settings.featureToggles['MANAGE_EMAILS']
              ? <ListItem
                className={classes.secondLevelItem}
                classes={{selected: classes.selectedItem}}
                component='a'
                href={`${settings.API_IPD_ROUTE_USER}/Pharma/Favorite`}
                target='_blank'
                button
              >
                <ListItemText classes={{root: classes.rootItemText, dense: classes.secondLevelItemText}} primary='Manage Favorites' />
              </ListItem>
              : null
            }
            {hasManageOwnUsers
              ? <ListItem
                className={classes.secondLevelItem}
                classes={{selected: classes.selectedItem}}
                component={Link}
                to={`/manage-users${qsEmail}`}
                selected={currentPath === '/manage-users'}
                button
              >
                <ListItemText classes={{dense: classes.secondLevelItemText}} primary='Manage Users' />
              </ListItem>
              : null
            }
            {hasManageOwnUsers
              ? <List className={classes.nestedNestedList} dense component='div'>
                <ListItem
                  className={classes.thirdLevelItem}
                  classes={{selected: classes.selectedItem}}
                  component={Link}
                  to={`/add-users${qsEmail}`}
                  selected={currentPath === '/add-users'}
                  button
                >
                  <ListItemText classes={{dense: classes.thirdLevelItemText}} primary='Add Users' />
                </ListItem>
                <ListItem
                  className={classes.thirdLevelItem}
                  classes={{selected: classes.selectedItem}}
                  component={Link}
                  to={`/deactivate-users${qsEmail}`}
                  selected={currentPath === '/deactivate-users'}
                  button
                >
                  <ListItemText classes={{dense: classes.thirdLevelItemText}} primary='Deactivate Users' />
                </ListItem>
              </List>
              : null
            }
          </List>
        </List>
        <div className={classes.accountHelp}>
          <span className={classes.helpTitle}>Account Help</span>
          <hr className={classes.helpHr} />
          <span className={classes.helpBody}>
            {`For account questions or coverage requests,
            please contact us at: `}
            <a href='mailto:hc@ipdanalytics.com'>hc@ipdanalytics.com</a> or (305) 662-8515
          </span>
        </div>
        {accountOwner
          ? <div className={classes.accountOwner}>
            Your Account Manager:<br />{accountOwner}
          </div>
          : null
        }
      </React.Fragment>
    )
  }
}
MenuComponent.propTypes = {
  claims: PropTypes.array.isRequired,
  currentApp: PropTypes.string,
  accountOwner: PropTypes.string
}

export default withStyles(styles)(MenuComponent)
